<template>
    <form class="AttachPostMedia border-t border-gray-300 pt-5" @submit.prevent="submit">
        <div v-if="!supportsContents" class="max-w-sm mx-auto">
            <FormItem :form="form" :field="'content_url'" help-block-class="text-left">
                <label class="control-label">Link til opslag #1</label>
                <div>
                    <input required="required" v-model="form.content_url" type="text"
                        class="form-control input-lg" placeholder="Link til opslag" />
                </div>
            </FormItem>

            <button type="submit" class="btn btn-xl btn-success btn-load" :disabled="form.busyOrSuccessful">
                Indsend opslag <i class="fa fa-arrow-right"></i>
            </button>
        </div>

        <div v-else class="mb-8">
            <div class="mb-4">
                <span v-if="form.contents.length === 0 && user_type === 'influencer'" class="text-sm">
                    Klik på 'Tilknyt opslag' når du har lavet dit opslag og vil melde jobbet
                    færdigt.
                </span>
                <ContentsGrid v-else :contents="form.contents" :color="'white'"/>
            </div>

            <div v-if="user_type === 'influencer' && showButton" class="sm:flex justify-center">
                <SelectContentsModal class="JobOverview__btn" v-bind="{ platform }" @selected="setSelectedContents">
                    <template v-slot:default="{ open }">
                        <button ref="attachBtn" type="button" class="btn btn-xl btn-default" @click="open">
                            1. Tilknyt opslag <i class="fa fa-plus"></i>
                        </button>
                    </template>
                </SelectContentsModal>

                <button ref="submitBtn" type="submit" class="btn btn-xl btn-success ml-4"
                    :disabled="!readyForSubmission || form.busy">
                    <span v-if="form.busy">
                        <i class="fa fa-spinner fa-spin"></i> Indsender...
                    </span>
                    <span v-else>
                        2. Indsend opslag <i class="fa fa-arrow-right"></i>
                    </span>
                </button>
            </div>
        </div>
    </form>
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import ContentsGrid from 'dashboard-js/components/contents/ContentsGrid'
import CreatesPopovers from 'dashboard-js/mixins/CreatesPopovers'
import FormItem from 'dashboard-js/components/utilities/FormItem'
import SelectContentsModal from 'dashboard-js/components/jobs/SelectContentsModal'

export default {
    components: { ContentsGrid, SelectContentsModal, FormItem },

    mixins: [CreatesPopovers],

    props: ['job', 'user_type', 'status'],

    data() {
        const blogCount = this.getBlogCount();
        const urls = this.initializeUrls(blogCount);

        return {
            form: new SparkForm({
                post_type: this.$attrs.post_type,
                form_number: this.$attrs.form_number,
                content_url: '',
                // content_urls: urls,
                contents: [],
                urls: [],
            }),
            hideButton: false,
        };
    },

    created() {
        if (this.$attrs.media && this.$attrs.media.length > 0) {
            this.$set(this.form, 'contents', this.$attrs.media)
        }
    },

    computed: {
        platform() {
            return this.job.jobable.platform
        },

        showButton() {
            return this.status === 'approved' || this.status === 'denied_media'
        },

        readyForSubmission() {
            return this.supportsContents
                ? this.form.contents.length > 0
                : this.form.content_url.length > 0
        },

        supportsContents() {
            return this.job.jobable.platform.supports_contents
        },
    },

    methods: {
        getBlogCount() {
            return 1; // Default value
        },

        initializeUrls(count) {
            return Array.from({ length: count }, () => ({ value: '' }));
        },

        setSelectedContents(contents) {
            this.$set(this.form, 'contents', contents)

            if (this.readyForSubmission) {
                setTimeout(() => {
                    this.popover(
                        this.$refs.submitBtn,
                        'Klik her for at melde jobbet færdig',
                        {
                            placement: 'top',
                        },
                        8000
                    )
                }, 1000)
            }
        },

        submit() {
            this.form.urls = []

            // this.form.content_urls.forEach((url) => {
            //     if (url.value && url.value.trim()) {
            //         const formattedUrl = this.withHttpProtocol(this.form.content_url)
            //         this.form.urls.push(formattedUrl)
            //     }
            // })

            this.form.contents.forEach((content) => {
                if (content.media_url && content.media_url.trim()) {
                    const formattedUrl = this.withHttpProtocol(content.media_url)
                    this.form.urls.push(formattedUrl)
                }
            })

            if (this.form.content_url && this.form.content_url.trim().length > 0) {
                this.form.content_url = this.withHttpProtocol(this.form.content_url)
            }

            Spark.post(route('api.job.action', [this.job.id, 'finishPostContent']), this.form).then(
                (response) => {
                    this.status = response.data.status
                },
            )
        },

        withHttpProtocol(url) {
            return url.indexOf('http') > -1 ? url : 'https://' + url
        },
    },
}
</script>
